<template>
    <div v-if="screen.active" class="loader" ref='loader'>
        
        <div class="content">
            <div class="icon">
            </div>
            <div class="copy">
                <p>Loading... Please Wait</p>
            </div>
            <div class="progress">
                <p>{{progress}}%</p>
            </div>

            
        </div>
    </div>
</template>

<style scoped>
    .loader {
        position : absolute;
        z-index: 7;
        left : 0;
        top : 0;
        width : 100%;
        height : 100%;
        background-color:rgba(0, 0, 0, 0.5);
        text-align: center;
        display : none;
    }

    .content {
        color: white;
        margin: auto;
        text-align: center;
    }

    .copy {
        margin: auto;
    }

    .progress {
        margin: auto;
    }

    .icon {
        left : 50%;
        top : 50%;
        border: 8px solid #f3f3f3; /* Light grey */
        border-top: 8px solid rgba(0,0,0,0); /* Transparent */
        border-radius: 80%;
        
        width: 120px;
        height: 120px;
        animation: spin 1s linear infinite;
        margin: auto;
    }

    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }
</style>
    

<script>
import {gsap} from 'gsap'

export default {
    data : function() {
        return {
            timeline : new gsap.timeline()
        }
    },

    computed : {
        screen(){ return this.$store.state.screens.loader },
        state(){return this.screen.state },
        loadStart(){ return this.$store.state.loadStart},
        loadComplete(){ return this.$store.state.loadComplete},
        progress(){ return Math.trunc(this.$store.state.loadProgress || 0) }
    },

    watch: {
        state(newState) { 
            if(newState == 'default') {
                this.hide();
            }

            if(newState == 'loading') {
                this.show();
            }
        },

        loadStart(){
            this.$store.commit('setState', {name : 'loader', state : 'loading'});
        },

        loadComplete(){
            this.$store.commit('setState', {name : 'loader', state : 'default'});
        },

        progress(value){
            console.log('progress:' , value)
        }

    },

    methods : {
        show() {
            let loader = this.$refs.loader;

            loader.style.display = 'flex';
            this.timeline.clear();
            this.timeline.set(loader, {autoAlpha: 0});
            this.timeline.to(loader, {autoAlpha : 1});
        },

        hide() {
            let loader = this.$refs.loader;

            this.timeline.clear();
            this.timeline.to(loader, {autoAlpha : 0, onComplete : () => loader.style.display = 'none'});
        },
    }
}
</script>